<template>
  <div>
    <header-sales></header-sales>

    <!--pc view-->
    <div v-if='!mobileView'>
      <div id="subheader"> </div> 
      <div id= "main-container"> 
        <div id= "label-container">
          <span id="label">Estado de Pedidos</span>
        </div> 
        <div id= "container">
          <div id="list-container">
            <item-estado-pedido id="list-prod" v-for="item in items" :item='item' @borradorEliminado="getEstadoPedidos"></item-estado-pedido>
          </div>
        </div> 
      </div> 
    </div>

    <!--mobile view-->
    <div v-if='mobileView'>
      <div class="fv ct" style="width: 100vw; height:100vh; margin-top:40px" >
        <div class="fh cc" style="width: 100%; height:4%; background:#44C7F4; color:white; font: size 12px;">Estado de Pedidos</div>
        <div class="fv ct" style="width: 100%; height:80%;" >
          <item-estado-pedido v-for="item in items" :item='item' @borradorEliminado="getEstadoPedidos"></item-estado-pedido>
        </div>
      </div>
    </div>

  </div>
</template>
 
  
  <script>
    import axios from 'axios'
    import HeaderSales from '@components/views/header.vue';
    import ItemEstadoPedido from '@components/views/estadoPedido/itemEstadoPedido.vue';
 
  
    export default {
      name: 'EstadoPedido',
      
      components:{
        'header-sales': HeaderSales,
        'item-estado-pedido': ItemEstadoPedido,
      },
      
      data() {
         return {
          pedidoRequest:null,
          items: [],
          mobileView:false
         }
      },  
  
      methods: {
  
        onResize() {
          if (window.innerWidth > 600) 
          {
            this.mobileView=false;
          }
          else 
          {
            this.mobileView=true;
          }
        },

        sortPedidos(v) {
          var saved = [], noSaved = [];
          for (var i = 0; i < v.length; i++)
          {
            if (v[i].Estado === 99) 
            {
              saved.push(v[i]);
            } 
            else 
            {
              noSaved.push(v[i]);
            }
          }
          noSaved.sort((a,b)=> {return b.Id - a.Id});
          return saved.concat(noSaved);
        },

        getEstadoPedidos() {
          this.$store.commit('loader/start')
          this.pedidoRequest = {
            'FechaDesde': "01/01/2000",
            'FechaHasta': this.getFechaHasta(),  
            'ClientesId': [this.$store.state.user.cliente.Id],
            'Estado': -1,
            'Pagina': 1,
            'PedidosXPagina': 100
          } 
          axios.post('/WebSalesPedidosListado', this.pedidoRequest ,{
            headers:{
              Token:        this.$store.state.user.usuario.Token,
              ClientSecret: this.$store.state.entorno.clientSecret,
              EmpresaId:    this.$store.state.entorno.idEmpresa
            }
          })
          .then((response) => {
                this.$store.commit('loader/stop')
                if (response.data.Code == 0) {
                    this.items = this.sortPedidos(response.data.Pedidos)  
                    this.items = this.items.filter((item) =>  {return item.Tipo == 1});
                    var pedidosHome = []
                    var presupuestosHome = []
                    var i 
                    if (response.data.Pedidos) {
                        for (i = 0; i < response.data.Pedidos.length; i++) { 
                            if ((response.data.Pedidos[i].Estado != 99) && (response.data.Pedidos[i].Tipo == 1) && (pedidosHome.length < 2)) {
                                pedidosHome.push(response.data.Pedidos[i])
                            } 
                            if ((response.data.Pedidos[i].Tipo == 2) && (presupuestosHome.length < 2)) {
                                presupuestosHome.push(response.data.Pedidos[i])
                            } 
                            if ((pedidosHome.length >= 2) && (presupuestosHome.length >= 2)) {
                                break
                            }
                        }
                        this.$store.commit('pedido/savePedidosHome',pedidosHome);
                        this.$store.commit('pedido/savePresupuestosHome',presupuestosHome);
                    }
                }
                else {
                    var obj = {
                        txt:response.data.Message,
                        txtBtnCancel:'',
                        txtBtnOk:'Aceptar',
                        fCancel:null,
                        fOk:null
                        }
                    this.$store.commit('popup/open',obj);
                }
            })
            .catch((error) => {
                alert(error) 
            });
        },

       getFechaHasta(){
          //'Fecha': "dd/mm/yyyy",  --> 1 dia mas que fecha actual 
          var date   =  new Date();
          date.setMilliseconds(date.getMilliseconds()+86400000) 
  
          var dia    =  ''
          var mes    =  ''
    
          if (date.getDate()<10)
          {
            dia = '0'+ date.getDate().toString()
          }
          else
          {
            dia = date.getDate().toString()
          }
  
          if ((date.getMonth() + 1)<10)
          {
            mes = '0'+ (date.getMonth()+1).toString()
          }
          else
          {
            mes = (date.getMonth()+1).toString()
          }
  
          return  dia+'/'+mes+'/'+date.getFullYear();
       },
    
      },
    
     mounted() {
        this.$store.commit('loader/stop')
        this.onResize()
        this.getEstadoPedidos();
     },

     created() {
       window.addEventListener('resize', this.onResize)
     },

      beforeDestroy() {
       window.removeEventListener('resize', this.onResize)
     }
 
    } 
    
  </script>
  
  
  <style scoped>
  
  
   #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
   }
  

      #main-container{
        position: absolute;
        top: 55vh;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 700px;
        height: 85vh;
        }

        #label-container{
        width: 700px;
        height: 10vh;
        }

        #label{
        color:#ffffff;
        font-size: 27px;
        }

        #container{
        width: 700px;
        height: 75vh;
        padding-top: 35px;
        border-width: 1px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        box-shadow: 3px 3px 4px #dddddd;
        background-color: #ffffff;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }

        #list-container{
        width: 660px;
        height: 65vh;
        background: #ffffff;
        overflow: auto;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }





  /* width */
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 
  
  /*::-webkit-scrollbar { 
      display: none; 
  }
  */
  
  </style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/estadoPedido.vue